window.jQuery = require('jquery');
window.$ = require('jquery');
require('./js-polyfills');
require('lazysizes');

window.Inputmask = require('inputmask');

require('./app');
require('./form');

require('./scroll-smooth');
